
var preFastHistoryModel = angular.module('preFastHistoryModel', []);
preFastHistoryModel.factory('PreFastHistoryFactory', function(ApplicationService, authServiceFactory, AppModelFactory, AbstractModelService){
	var PreFastHistory = function(){
		this.endpoint = "/preFastHistory";
		this.primaryKey = "recordID";
	}
	PreFastHistory.prototype = new AppModelFactory();
	PreFastHistory.prototype.parent = AppModelFactory.prototype;

	PreFastHistory.prototype.post = function(id, data, instance)
	{
		return AbstractModelService.post("/api/app/" + id + "/preFastHistory", data, instance);
	}
	return PreFastHistory;
});

preFastHistoryModel.service('PreFastHistoryService', function(PreFastHistoryFactory){
	var preFastHistoryModel = new PreFastHistoryFactory();
	return preFastHistoryModel;
});
